export default __webpack_public_path__ + "static/abhaziya-celo-pskhu-cerkov-useknoveniya-glavy-ioanna-predtechi_2-8341230a80d792f8127f67702c099dca.jpg";